define('presentation/signup/viewModels/signupSuccessViewModel',[
    'i18next',
    'businessServices/signup/signupSessionStore',
    'businessServices/signup/signupWebAppSignIn',
    'common/promises/promiseFactory',
    'settings/navigationConfiguration'
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
        const _signupSessionStore = new SignupSessionStoreConstructor();

        const SignupWebAppSignInConstructor = require('businessServices/signup/signupWebAppSignIn');
        const _signupWebAppSignIn = new SignupWebAppSignInConstructor();

        const _i18n = require('i18next');
        const _navigationConfiguration = require('settings/navigationConfiguration');

        self.isCompositionComplete = ko.observable(false);

        let _isNavigating = false;

        self.headingText = _i18n.t('signupSuccess:headingText');
        self.nextPageButtonText = _i18n.t('signupSuccess:goToMyAccount');
        self.infoMessage = '';
        self.infoSteps = [];

        self.onSignInToWebApp = () => {
            _signupWebAppSignIn.signInToWebApp(_navigationConfiguration.signupLandingPage, false);
        };

        self.onContinue = () => {
            return _promiseFactory.deferWithMinimumWait(deferredObject => {
                if (_isNavigating) {
                    deferredObject.resolve({keepSpinning: true});
                    return;
                }
                _isNavigating = true;

                self.onSignInToWebApp();

                deferredObject.resolve({keepSpinning: true});
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            _signupWebAppSignIn.init();

            return _initialize();
        };

        const _hasPackage = (packageId) => {
            return packageId !== null && packageId !== undefined && packageId !== "";
        };

        const _setInfoContent = (signupDocument) => {
            const hasLiveReceptionist = _hasPackage(signupDocument.liveReceptionistPackageId);
            const hasWebChat = _hasPackage(signupDocument.webChatPackageId);
            const hasOutboundCalling = _hasPackage(signupDocument.outboundCallingPackageId);
            const serviceCount = [hasLiveReceptionist, hasWebChat, hasOutboundCalling].filter(hasService => hasService).length;

            if (serviceCount > 1) {
                self.infoMessage = _i18n.t('signupSuccess:infoMessageMixedServices');
            } else if (hasLiveReceptionist) {
                self.infoMessage = _i18n.t('signupSuccess:infoMessageLiveReceptionistOnly');
                self.infoSteps = [
                    _i18n.t('signupSuccess:infoStepLiveReceptionistOnlyOnline'),
                    _i18n.t('signupSuccess:infoStepLiveReceptionistOnlyCall')
                ];
            } else if (hasWebChat) {
                self.infoMessage = _i18n.t('signupSuccess:infoMessageWebChatOnly');
            } else if (hasOutboundCalling) {
                self.infoMessage = _i18n.t('signupSuccess:infoMessageOutboundCallingOnly');
            } else {
                self.infoMessage = _i18n.t('signupSuccess:infoMessageNoOnboarding');
            }
        };

        // Read before sign-in, which clears the signup session.
        const _initialize = () => {
            return _promiseFactory.defer(deferredObject => {
                _signupSessionStore.init();
                _signupSessionStore.getState()
                    .fail(deferredObject.reject)
                    .done(signupSession => {
                        _setInfoContent(signupSession.signupDocument);
                        deferredObject.resolve();
                    });
            });
        };
    };
});

